import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import PrimeVue from 'primevue/config'
import Toast from 'primevue/toast'
import ToastService from 'primevue/toastservice'
import FileUpload from 'primevue/fileupload'
import { FontAwesomeIcon } from './plugins/font-awesome'
import 'primevue/resources/themes/saga-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'
import './assets/main.css'
import '@fortawesome/fontawesome-svg-core/styles.css'
import VueGtm from 'vue-gtm'

const app = createApp(App)

app.use(store)
app.use(router)
app.use(PrimeVue, { ripple: true })
app.use(ToastService)
app.use(VueGtm, {
    id: process.env.VUE_APP_GTM_ID,
    enabled: process.env.VUE_APP_MODE === 'production',
    debug: true,
    vueRouter: null,
})

app.component('Toast', Toast)
app.component('FileUpload', FileUpload)
app.component('FontAwesomeIcon', FontAwesomeIcon)

app.mount('#app') 